import { useLocation } from 'react-router-dom';
import useQuery from '../useQuery';

function useUrlParams() {
	const urlQuery = useQuery();
	return Object.fromEntries(urlQuery.entries());
}

export default useUrlParams;
